






import { defineComponent } from '@vue/composition-api';
import AudioTrack from '@/components/storyblok/AudioTrack.vue';

export default defineComponent({
  name: 'AudioTracks',
  props: { blok: { type: Object } },
  components: { AudioTrack },
});
